import React, { useEffect, useState } from "react";
import { Card } from "@modules/MyBottleCollection/Card";
import type { Hit } from "react-instantsearch-core";
import { AlgoliaBottle } from "../../../carlsberg-headless/types/modules/digital-memories";

type HitsProps = {
  hits: Hit<AlgoliaBottle>[];
  narrowList: boolean;
  openDetail: (index: number, id: string) => void;
};

type Card = Hit<AlgoliaBottle> & {
  index: number;
  largeCard: boolean;
};

const largeCards = [4, 15, 34, 45, 64, 75];

export const Hits: React.FC<HitsProps> = ({ hits, narrowList, openDetail }) => {
  const [allHits, setAllHits] = useState<Card[]>([]);

  useEffect(() => {
    if (hits && hits.length !== 0) {
      const items = hits.map((props, key) => {
        let showAsLargeCard = false;

        if (largeCards.includes(key)) {
          showAsLargeCard = true;
        }

        return { ...props, index: key, largeCard: showAsLargeCard };
      }) as unknown as Card[];

      setAllHits(items);
    } else {
      setAllHits([]);
    }
  }, [hits]);

  return (
    <>
      {allHits.length !== 0
        ? allHits.map((props, key) => (
            <Card
              {...props}
              key={props.id}
              onClick={() => openDetail(key, props.id)}
              largeCard={narrowList ? false : props.largeCard}
            />
          ))
        : null}
    </>
  );
};
